export class SelectionPlusFieldParameter {
  minSelection: number | undefined;
  maxSelection: number | undefined;
  items: string[] | undefined;
  forceAdditionalField = false;
  sum = false;
  suffix: string | undefined;
}
